<template>
  <el-dialog
    title="选择指导老师"
    :visible.sync="chooserDialog"
    :before-close="resetForm"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-divider />
    <div class="form-box">
      <div class="search">
        <div class="leftcontain">
          <div class="text">搜索：</div>
          <el-input
            v-model="queryParams.keyword"
            placeholder="请输入老师工号/姓名"
          ></el-input>
        </div>
        <div class="rightcontain">
          <el-button
            type="primary"
            @click="searchbt"
            style="background: #3d84ff"
            >查询</el-button
          >
          <el-button type="info" @click="resetbt">重置</el-button>
        </div>
      </div>
      <div class="main-contain">
        <div class="contain">
          <el-table
            ref="multipleTable"
            :data="listData"
            highlight-current-row
            style="width: 100%"
            class="Table"
            :header-cell-style="{
              'font-size': '15px',
              color: '#666666',
              'font-weight': 'bold',
              background: '#F7F7F7',
            }"
            :row-style="{
              'font-size': '15px',
              color: '#222222',
              'font-weight': '400',
            }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
            <el-table-column prop="teacher_sn" label="老师编号"></el-table-column>
            <el-table-column prop="name" label="老师姓名"></el-table-column>
            <el-table-column prop="college_name" label="所属院系"></el-table-column>
          </el-table>
          <div class="elpagination">
            <div class="elpagination-title">共{{ total }}条</div>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="queryParams.per_page"
              :pager-count="5"
              :current-page="queryParams.page"
              @current-change="pageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="el-dialog__footer">
      <el-button type="primary" plain @click="resetForm">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dayjs from "dayjs";
import { choosePlanTea, addPlanTea } from "@/api/practiceattendance";
export default {
  name: "addCategory",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chooserDialog: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      queryParams: {
        keyword: "",
        page: 1,
        per_page: 10,
        is_leader: 1,
        plan_id:"",
      },
      practice_plan_student_id: '',
      total: 0,
      listData: [],
      multipleSelection: [],
      practice_teacher_list: [],
    };
  },
  methods: {
    //查询
    searchbt() {
      this.queryParams.page = 1
      this.loadData();
    },
    //重置
    resetbt() {
      this.queryParams.page = 1
      this.queryParams.per_page = 10
      this.queryParams.keyword = ''
      this.multipleSelection = []
      this.loadData();
    },
    //加载信息
    loadObj(plan_id,practice_plan_student_id,practice_teacher_id) {
      this.queryParams.plan_id = plan_id;
      this.practice_plan_student_id = practice_plan_student_id;
      this.practice_teacher_list = practice_teacher_id ? practice_teacher_id.split(",") : [];
      this.resetbt();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //提交
    submitForm() {
      let that = this;
			let idList = [];
      let multipleSelection = that.multipleSelection;
			for(let i in multipleSelection){
				idList.push(multipleSelection[i].id)
			}
			if(!idList.length){
				return that.$message.warning(`请选择指导老师`)
			}
      // for(let i in multipleSelection){
      //   for(let j in idList){
      //     if(multipleSelection[i].id == idList[j] && multipleSelection[i].select_counStr === '放开'){
      //       return that.$message.warning(multipleSelection[i].teacher_sn +'人数已满')
      //     }
      //   }
			// }
			let param = {
				teacher_ids: idList.join(","),
				practice_plan_student_ids: that.practice_plan_student_id
			}
      console.log("提交",param)
      addPlanTea(param).then((res) => {
         if (res.code === 0) {
           that.$message.success("操作成功");
           that.resetForm();
           that.$emit("updChooser", "刷新");
         }
      }).catch(() => {});
    },
    //取消
    resetForm() {
      this.chooserDialog = false;
    },
    checkSelectable (row){
      return row.select_count !== 0 || row.select_counStr === '放开';//人数已满并且选中放开
    },
    //获取列表
    loadData() {
      let params = this.queryParams;
      console.log("查询",params)
      choosePlanTea(params).then((response) => {
         if (response.code === 0) {
           this.total = response.data.total;
           this.listData = response.data.data;
           const multipleTable = this.$refs.multipleTable; // 确保这里的ref与template中的一致
           for(let i in this.listData){
            this.listData[i].select_counStr = this.listData[i].select_count 
            multipleTable.toggleRowSelection(this.listData[i], false);
            for(let j in this.practice_teacher_list){
              // if(this.listData[i].id == this.practice_teacher_list[j] && this.listData[i].select_count !=0){
              if(this.listData[i].id == this.practice_teacher_list[j]){
                this.listData[i].select_counStr = '放开'
                this.$nextTick(() => {
                  if (multipleTable) {
                    multipleTable.toggleRowSelection(this.listData[i], true);
                  }
                });
              }
            }
          }
         }
      }).catch((error) => { });
    },
    // 分页-切换页面
    pageChange(data) {
      this.queryParams.page = data;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 30px 20px;
  .search {
    .leftcontain {
      display: flex;
      float: left;
      .text {
        margin: 6px 10px 0 0;
        font-size: 16px;
        font-weight: 400;
        color: #888888;
      }
      .el-input {
        width: 200px;
      }
    }
    .rightcontain {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0 0px 15px;
      float: right;
      .bt {
        width: 64px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #3d84ff;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #3d84ff;
        user-select: none;
        cursor: pointer;
      }

      .bt1 {
        margin-left: 10px;
        margin-right: 10px;
        background: #3d84ff;
        color: white;
      }
    }
  }
  .main-contain {
    margin-left: 10px;
    margin-right: 10px;
    height: 100%;
    width: 100%;

    .elpagination {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .elpagination-title {
        margin-right: 4px;
      }
    }
  }
}
::v-deep .el-dialog__header {
  padding: 20px;
}
::v-deep .el-dialog__body {
  padding: 0;
  .el-divider--horizontal {
    margin: 0 0 24px;
  }
}
.el-dialog__footer {
  clear: both;
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  border-top: solid 1px #eeeeee;
}
</style>
